module.exports = require('./helpers/bundle-url').getBundleURL('QXyrT') + "world.4cdfbc40.svg";